export default __webpack_public_path__ + "static/media/did_verification_text.b3ffadab.png";